import React from 'react';
import PropTypes from 'prop-types';

const CloseIcon = ({ color = '#18964E', width = 12, height = 12 }) => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 11L11 1" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M11 11L1 1" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
);

CloseIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default CloseIcon; 